var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M18 12H4v-2h14z"}})}
var staticRenderFns = []

export { render, staticRenderFns }